import React, { useState } from 'react';
import { string, bool, func } from 'prop-types';

import { Modal, Icon, Hint } from '@atoms';
import { Flex, Typography } from '@mixins';
import { ReactComponent as CopyReferral } from '@assets/svgs/CopyReferral.svg';
import { ReactComponent as Referral } from '@assets/svgs/Referral.svg';
import { ReactComponent as FacebookReferral } from '@assets/svgs/FacebookReferral.svg';
import { ReactComponent as TwitterReferral } from '@assets/svgs/TwitterReferral.svg';
import { ReactComponent as EmailReferral } from '@assets/svgs/EmailReferral.svg';
import { ReactComponent as WhatsappReferral } from '@assets/svgs/WhatsappReferral.svg';

const ReferFriendModal = ({ isOpen, onModalClose, link, text, title }) => {
  const [isLinkCopied, setIsLinkCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(link);
  };

  const handleLinkCopy = () => {
    setIsLinkCopied(true);
    handleCopy();
  };

  const handleHintClose = () => {
    setIsLinkCopied(false);
  };

  const handleTwitterClick = () => {
    window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(link)}&text=${title}%20-%20${text}`);
  };

  const handleFacebookClick = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}`);
  };

  const handleEmailClick = () => {
    window.open(`mailto:?subject=${title}&body=${text}%0A%0A${encodeURIComponent(link)}`);
  };

  const handleWhatsappClick = () => {
    window.open(`https://wa.me/?text=${title}%20-%20${text}%20${encodeURIComponent(link)}`);
  };

  return (
    <Modal isOpen={isOpen} onClose={onModalClose} topPosition={250}>
      <Flex alignItems="center" width={560} flexDirection="column">
        <Flex mb={30} flexDirection="column" alignItems="center">
          <Icon SVG={Referral} mb={[10, 10, 15]} />
          <Typography variant="diatype-500" fontSize={[20]}>
            Share your referral
          </Typography>
        </Flex>
        <Flex position="relative">
          <Hint title="Link copied" isOpen={isLinkCopied} onClose={handleHintClose} />
          <Flex
            onClick={handleLinkCopy}
            mb="15px"
            py="4px"
            border="1px solid #EFECE6"
            pointer
            alignItems="center"
            justifyContent="center"
            width={280}>
            <Icon SVG={CopyReferral} mr={10} />
            <Typography variant="diatype-400" fontSize={16}>
              Copy Link
            </Typography>
          </Flex>
        </Flex>
        <Flex mb={15} width={280} justifyContent="space-between">
          <Flex
            onClick={handleEmailClick}
            width="47%"
            py="4px"
            border="1px solid #EFECE6"
            pointer
            alignItems="center"
            px="10px">
            <Icon SVG={EmailReferral} mr={10} />
            <Typography variant="diatype-400" fontSize={16}>
              Email
            </Typography>
          </Flex>
          <Flex
            onClick={handleWhatsappClick}
            width="47%"
            py="4px"
            border="1px solid #EFECE6"
            pointer
            alignItems="center"
            px="10px">
            <Icon SVG={WhatsappReferral} mr={10} />
            <Typography variant="diatype-400" fontSize={16}>
              WhatsApp
            </Typography>
          </Flex>
        </Flex>
        <Flex width={280} justifyContent="space-between">
          <Flex
            onClick={handleTwitterClick}
            width="47%"
            py="4px"
            border="1px solid #EFECE6"
            pointer
            alignItems="center"
            px="10px">
            <Icon SVG={TwitterReferral} mr={10} />
            <Typography variant="diatype-400" fontSize={16}>
              Twitter
            </Typography>
          </Flex>
          <Flex
            onClick={handleFacebookClick}
            width="47%"
            py="4px"
            border="1px solid #EFECE6"
            pointer
            alignItems="center"
            px="10px">
            <Icon SVG={FacebookReferral} mr={10} />
            <Typography variant="diatype-400" fontSize={16}>
              Facebook
            </Typography>
          </Flex>
        </Flex>
      </Flex>
    </Modal>
  );
};

ReferFriendModal.propTypes = {
  isOpen: bool.isRequired,
  link: string.isRequired,
  text: string.isRequired,
  title: string.isRequired,
  onModalClose: func.isRequired,
};

export default ReferFriendModal;
